import { useEffect, useState, useMemo } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import Modal from './Modal';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { webpIsSupported } from '@/utils/imageUtils';

const A2: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { t } = useLang('stream_ultra_x');

    const brands: string[] = [
        'https://websiteoss.ecoflow.com/upload/image/1755065988096/1_1.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1756978443167-114et8-compressed-%E8%AE%A4%E8%AF%81logo.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1756978464059-ogxill-compressed-GIA24_HO_WINNER_MC_RGB%201.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1756978477187-wi1tvb-compressed-Yello%20App%202.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1756978481286-ly8ljj-compressed-%E8%AE%A4%E8%AF%81logo.png',
    ];

    const Desc = () => {
        return (
            <div>
                <div className="logo-wrapper">
                    <EcoImg className="logo1" pc="https://websiteoss.ecoflow.com/figma-uploads/1756975094645-7plci9-compressed-logo%E7%BB%84%E4%BB%B6.png" />
                    <span className="line"></span>
                    <EcoImg
                        className="logo2"
                        pc="https://websiteoss.ecoflow.com/figma-uploads/1756975276896-n7hijt-compressed-Invented%20for%20life%20%20Bosch%20Global%202.png"
                    />
                    {/* <span className="line"></span>
                    <EcoImg className="logo3" pc="https://websiteoss.ecoflow.com/figma-uploads/1756975280009-awzfpj-compressed-Ebene_1.png" /> */}
                </div>

                <div className="desc-wrapper">
                    <p className="desc">
                        {/* Stay updated > 转义 */}
                        {t('A2_desc')}
                        <span onClick={() => setIsModalOpen(true)}>{t('A2_stay_updated')}</span>
                    </p>
                </div>
            </div>
        );
    };

    // const [isWebpSupported, setIsWebpSupported] = useState<boolean | null>(null);

    // useEffect(() => {
    //     webpIsSupported().then((supported) => {
    //         console.log('supported', supported);
    //         setIsWebpSupported(supported);
    //     });
    // }, []);

    // const imageUrls = useMemo(() => {
    //     const useWebp = isWebpSupported === true;
    //     return {
    //         pc: useWebp
    //             ? 'https://websiteoss.ecoflow.com/upload/image/1757056702579/2560_KV.webp'
    //             : 'https://websiteoss.ecoflow.com/upload/image/1757056620050/2560_KV.jpg',
    //         pad: useWebp
    //             ? 'https://websiteoss.ecoflow.com/upload/image/1757056702579/2560_KV.webp'
    //             : 'https://websiteoss.ecoflow.com/upload/image/1757056620050/2560_KV.jpg',
    //         h5: useWebp
    //             ? 'https://websiteoss.ecoflow.com/upload/image/1757056702405/mob_KV.webp'
    //             : 'https://websiteoss.ecoflow.com/upload/image/1757056619840/mob_KV.jpg',
    //     };
    // }, [isWebpSupported]);

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        // ...imageUrls,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1757056620050/2560_KV.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1757056620050/2560_KV.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1757056619840/mob_KV.jpg',
        // label: t('label'),
        // labelColor: '#D11504',
        label: t('A_label'),
        title: t('A_title'),
        desc: <Desc />,
    };
    // 在 WebP 检测完成前不渲染图片，避免闪烁
    // if (isWebpSupported === null) {
    //     return (
    //         <div id="banner" className={styles.A2}>
    //             <div style={{ minHeight: '600px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}></div>
    //         </div>
    //     );
    // }

    return (
        <div id="banner" className={styles.A2}>
            <EcoBanner theme="white" {...dataA} />
            <div className="footer-wrapper">
                <div className="footer-desc ">
                    <div className="brands">
                        {brands.map((item, index) => (
                            <img key={index} className="brand" src={item} alt={'brand logo'} />
                        ))}
                    </div>
                    <div className="footer-desc-text">{t('A2_footer_desc')}</div>
                </div>
            </div>
            <Modal visible={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>
    );
};

export default A2;
